import React from 'react';

import LockIcon from '@mui/icons-material/Lock';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

import { NoColorLink } from 'ui/NoColorLink';
import { NavLinkProps } from './helpers/types';
import StyButton from './StyButton';
import { useInternalLinkAccess } from './hooks/useInternalLinkAccess';

const StyDisabled = styled(Box, {
    name: 'StyDisabled',
})(({ theme }) => ({
    alignItems: 'center',
    color: theme.palette.lightGrey,
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'center',
}));

const InternalLink = ({
    children,
    url,
    disabled,
    backgroundColor,
    fontColor,
}: NavLinkProps) => {
    const { href, pathname } = new URL(url);

    const { isDisabled, tooltipMessage } = useInternalLinkAccess(
        pathname,
        disabled,
    );

    if (isDisabled) {
        return (
            <Tooltip title={tooltipMessage}>
                <StyDisabled sx={{ backgroundColor }}>
                    <LockIcon
                        sx={{ ml: '20px', color: fontColor }}
                        fontSize="small"
                    />
                    {children}
                </StyDisabled>
            </Tooltip>
        );
    }
    return (
        <StyButton
            component={NoColorLink}
            sx={{ justifyContent: 'center' }}
            backgroundColor={backgroundColor}
            to={href}
        >
            {children}
        </StyButton>
    );
};

export default React.memo(InternalLink);
